import React, { useEffect, useState } from "react";
import { View } from "react-native";

import { InputLabel, ParentCatPicker } from "components";
import FiltersTemplate from "screens/components/FiltersTemplate";

import { strings } from "assets/constants";
import { filtersItems } from "assets/data";
import css from "styles";

export interface ProductsFiltersT {
  category?: PickerItemT;
}

export default function Filters(props: {
  visible: boolean;
  hide?: () => void;
  initials: ProductsFiltersT;
  apply?: (newFilters: ProductsFiltersT) => void;
}) {
  const { initials, hide, apply, visible } = props;

  const [innerFilters, setInnerFilters] = useState(initials);

  useEffect(() => setInnerFilters(initials), [initials]);

  const _onApply = () => apply && apply(innerFilters);
  const _onCancel = () => {
    setInnerFilters(initials);
    hide && hide();
  };

  return (
    <FiltersTemplate
      filtersItems={filtersItems.products}
      innerFilters={innerFilters}
      setInnerFilters={setInnerFilters}
      visible={visible}
      _onApply={_onApply}
      _onCancel={_onCancel}
    >
      <>
        <InputLabel label={strings.product_cat} />
        <ParentCatPicker
          showChild
          value={innerFilters.category}
          placeholder={strings.pick_product_cat}
          onSelect={(category) =>
            setInnerFilters({ ...innerFilters, category })
          }
        />
      </>
    </FiltersTemplate>
  );
}
